/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Group_Removed_SuccessInputs */

const en_team_manager_group_removed_success = /** @type {(inputs: Team_Manager_Group_Removed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group was successfully removed`)
};

const fr_team_manager_group_removed_success = /** @type {(inputs: Team_Manager_Group_Removed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe supprimé avec succès`)
};

const de_team_manager_group_removed_success = /** @type {(inputs: Team_Manager_Group_Removed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Gruppe wurde erfolgreich entfernt`)
};

const it_team_manager_group_removed_success = /** @type {(inputs: Team_Manager_Group_Removed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il gruppo è stato rimosso con successo`)
};

const ru_team_manager_group_removed_success = /** @type {(inputs: Team_Manager_Group_Removed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа была успешно удалена.`)
};

const es_team_manager_group_removed_success = /** @type {(inputs: Team_Manager_Group_Removed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El grupo fue eliminado exitosamente`)
};

const zh_cn2_team_manager_group_removed_success = /** @type {(inputs: Team_Manager_Group_Removed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该组已成功移除`)
};

const ja_team_manager_group_removed_success = /** @type {(inputs: Team_Manager_Group_Removed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループが正常に削除されました`)
};

const hi_team_manager_group_removed_success = /** @type {(inputs: Team_Manager_Group_Removed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह को सफलतापूर्वक हटा दिया गया।`)
};

const pt_pt2_team_manager_group_removed_success = /** @type {(inputs: Team_Manager_Group_Removed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O grupo foi removido com sucesso.`)
};

/**
* | output |
* | --- |
* | "Group was successfully removed" |
*
* @param {Team_Manager_Group_Removed_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_group_removed_success = /** @type {((inputs?: Team_Manager_Group_Removed_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Group_Removed_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_group_removed_success(inputs)
	if (locale === "de") return de_team_manager_group_removed_success(inputs)
	if (locale === "it") return it_team_manager_group_removed_success(inputs)
	if (locale === "ru") return ru_team_manager_group_removed_success(inputs)
	if (locale === "es") return es_team_manager_group_removed_success(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_group_removed_success(inputs)
	if (locale === "ja") return ja_team_manager_group_removed_success(inputs)
	if (locale === "hi") return hi_team_manager_group_removed_success(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_group_removed_success(inputs)
	return en_team_manager_group_removed_success(inputs)
});